import React, { useReducer, createContext, useEffect } from "react";

export const RolesContext = createContext();

const initialState = {
  customers: [],
  roles: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "USER":
      return action.payload.value;
    case "USER_UPDATE":
      return {
        ...state,
        [action.payload.title]: action.payload.value,
      };
    default:
      throw new Error();
  }
};
export const RolesContextProvider = (props) => {
  const [stateroles, dispatchroles] = useReducer(reducer, initialState);
  return (
    <RolesContext.Provider value={[stateroles, dispatchroles]}>
      {props.children}
    </RolesContext.Provider>
  );
};
